import { render, staticRenderFns } from "./WorkflowFormFormulate.vue?vue&type=template&id=d6909a12"
import script from "./WorkflowFormFormulate.vue?vue&type=script&lang=js"
export * from "./WorkflowFormFormulate.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFormFormulate.vue?vue&type=style&index=0&id=d6909a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports